import { render, staticRenderFns } from "./postQuestion.vue?vue&type=template&id=61a6ece8&scoped=true"
import script from "./postQuestion.vue?vue&type=script&lang=js"
export * from "./postQuestion.vue?vue&type=script&lang=js"
import style0 from "./postQuestion.vue?vue&type=style&index=0&id=61a6ece8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a6ece8",
  null
  
)

export default component.exports